<div class="d-flex align-items-center">
  <div
    class="c-field-value__shape-circle -sale-status mr-6"
    [ngClass]="{
      '-pending': status === statusTranslations[AFFILIATE_REQUEST_STATUSES.REQUESTED],
      '-active': status === statusTranslations[AFFILIATE_REQUEST_STATUSES.APPROVED],
      '-blocked': status === statusTranslations[AFFILIATE_REQUEST_STATUSES.DECLINED],
      '-paused': status === 'Unknown'
    }"
  ></div>
  <gtd-ui-field-default-string-or-empty [data]="status"></gtd-ui-field-default-string-or-empty>
</div>
